module.exports = __webpack_public_path__ + "img/ssbg7.6c3641fb.jpg";